import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import {
    WithStyles,
    Theme,
    createStyles,
    Grid,
    Typography,
    Button,
    withStyles,
    Menu,
    MenuItem,
    Card,
    CardContent,
    Paper,
    Avatar,
    List,
    ListItem,
    ListItemText,
    LinearProgress,
} from '@material-ui/core';

import courseService from '../../mylibrary/services/courseService';

import {
    MoreVert as MoreIcon,
    KeyboardBackspace as BackIcon,
    Close as CloseIcon,
    Add as AddIcon,
} from '@material-ui/icons';

import Icon from '@material-ui/core/Icon';

import { MyPATIconButton, MyPATLink, MyPATExpansionPanel, SearchField } from '../../common';
import { getMaster } from '../actions/goalManagementActions';
import { getCourseData } from '../actions/goalManagementActions';
import GoalManagementService from '../services/goalManagementService';

const styles = (theme: Theme) => createStyles({
    mb2x: {
        marginBottom: theme.spacing.unit * 2,
    },
    root: {
        flexGrow: 1,
        padding: 0,
    },
    pageTitle: {
        '& > *': {
            marginRight: theme.spacing.unit,
        },
        '& > svg': {
            fontSize: '2em',
        }
    },
    activeSelected: {
        backgroundColor: theme.palette.primary.main + "!important",
        '& *': {
            color: theme.palette.common.white,
        },
    },
    editGoalCardContent: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },
    progressWrapper: {

    },
    smallText: {
        position: "absolute",
        bottom: 0,
        right: "30px",
    },
    pT6: {
        paddingTop: "6px",
    },
    list: {
        '& div:first-child': {
            padding: 0,
            '& span:first-child': {
                marginBottom: theme.spacing.unit / 2,
            }
        }
    },
    unmappedInfo: {
        padding: theme.spacing.unit * 2,
        paddingBottom: 0,
        opacity: 0.54,
    },
    notMapped: {
        paddingLeft: theme.spacing.unit * 5,
    },
    mapping: {
        border: "1px solid #e0e0e0",
    },
    subHeader: {
        padding: theme.spacing.unit,
        fontSize: theme.spacing.unit * 2,
        fontWeight: 700,
        borderBottom: "0.5px solid #e0e0e0",
    },
    umMappedHeader: {
        padding: theme.spacing.unit,
        fontSize: theme.spacing.unit * 2,
        fontWeight: 700,
    },
    progressBar: {
        width: '120%',
        display: 'inline-block',
        height: theme.spacing.unit / 2,
        backgroundColor: theme.palette.grey[400],
        borderRadius: theme.spacing.unit / 2,
    },

    btnAddNewGoal: {
        marginRight: theme.spacing.unit * 2,
    },
    paper: {
        width: "98%",
        padding: 0,
        color: theme.palette.text.secondary,
    },
    cardMinHeigth: {
        minHeight: "250px",
        padding: 0
    },
    moreMenu: {
        '& li': {
            height: theme.spacing.unit * 2,
            color: theme.palette.text.secondary,
            fontSize: '0.8rem',
            paddingTop: theme.spacing.unit,
            paddingBottom: theme.spacing.unit,
            '& > svg': {
                marginRight: theme.spacing.unit,
                fontSize: '1rem',
            }
        }
    },
    goalCardContent: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        '&:last-child': {
            paddingBottom: theme.spacing.unit * 2,
        },
    },

    goalIconGrid: {
        paddingRight: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        borderRight: `1px solid ${theme.palette.grey[400]}`,
        '& > div': {
            height: theme.spacing.unit * 10,
            width: theme.spacing.unit * 10,
            border: `3px solid #785BC3`,
            color: '#785BC3',
            textAlign: 'center',
            backgroundColor: theme.palette.common.white,
            '& span': {
                display: 'inline-block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                fontWeight: theme.typography.fontWeightMedium
            }
        },
    },
    cardWidth: {
        width: "400px",
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 2,
        borderRadius: theme.spacing.unit,
        boxShadow: "0px 0px 6px rgba(0, 0, 0, 0.294865)"
    },
    moreMenuButton: {
        position: 'absolute',
        right: "6px",
        top: "6px",
    },
    masterMoreMenuButton: {
        position: 'absolute',
        top: "7px",
        left: 0
    },
    addIcon: {
        borderRadius: theme.spacing.unit * 2,
        background: theme.palette.grey[300],
    },
    closeIcon: {
        borderRadius: theme.spacing.unit * 2,
        background: theme.palette.grey[300],
        padding: "3px",
    },
    fwNormal: {
        fontWeight: theme.typography.fontWeightRegular,
    },
    cardParent: {
        background: "#F7F7F7",
        display: "flex",
        paddingTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    },
    chapterBorder: {
        borderBottom: "1px solid #e0e0e0",
        '& div:first-child': {
            paddingLeft: theme.spacing.unit,
        }
    },
    inMaster: {
        background: "#fff",
    },
    yourChapter: {
        padding: theme.spacing.unit * 2,
        '& div': {
            fontSize: "20px",
            fontWeight: theme.typography.fontWeightMedium,
        }
    },
    pB8: {
        paddingBottom: theme.spacing.unit,
    },
    searchInputRoot: {
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.borderRadius * 5,
        paddingLeft: theme.spacing.unit * 2,
        paddingRight: theme.spacing.unit,
        '& div > svg': {
            fontSize: theme.spacing.unit * 3,
        }
    },
    p12: {
        padding: "12px",
    },
    uniqueIdText: {
        fontSize: "16px",
        color: "#666666",
        fontWeight: "normal",
    }

});





interface ConceptMappingContainerProps extends WithStyles<typeof styles> {
    history: any,
    location: any,
    match: any,
    getMaster: (getMasterBy: string, id: string, classId: string, courseId?: string) => void,
    getCourseData: (courseId: string) => void,
    masterConcept: any,
    courseData: any,
}

interface ConceptMappingContainerState {
    moreMenuAnchor: any,
    yourConcept: any,
    tempMasterConcept: any,
    yourConceptWithParent: any,
    selectedConceptId: string,
    tempYourConcept: any,
    updateProps: boolean,
    unMappedData: any,
    mappedPer: number,
}

class ConceptMappingContainer extends Component<ConceptMappingContainerProps, ConceptMappingContainerState> {
    constructor(props: ConceptMappingContainerProps) {
        super(props);
        this.state = {
            moreMenuAnchor: null,
            yourConcept: [],
            tempYourConcept: [],
            yourConceptWithParent: {},
            tempMasterConcept: [],
            selectedConceptId: '',
            updateProps: true,
            unMappedData: [],
            mappedPer: 0,
        };

        this.handleMoreMenuOpen = this.handleMoreMenuOpen.bind(this);
        this.handleSearchYourConcept = this.handleSearchYourConcept.bind(this);
        this.handleSearchMaster = this.handleSearchMaster.bind(this);
        this.calculateProgress = this.calculateProgress.bind(this);
    }

    componentDidMount() {
        let { parentId, courseId, classId, chapterId } = this.props.match.params;
        let { yourConcept, unMappedData } = this.state;
        GoalManagementService.getLocalEntry(courseId, parentId)
            .then((res: any) => {
                unMappedData = res;
                yourConcept = res && res.filter((rs: any) => {
                    if(rs.parent && rs.parent.id){
                        return rs.parent.id == parentId
                    }else{
                        return rs.parent == parentId
                   }
                });
                this.setState({ yourConcept, tempYourConcept: yourConcept, unMappedData });
            });

        this.props.getMaster('concept', chapterId, classId, courseId);
        this.props.getCourseData(courseId);
    }

    handleMoreMenuOpen = (evt: any) => this.setState({ moreMenuAnchor: evt.currentTarget });
    handleMoreMenuClose = () => this.setState({ moreMenuAnchor: null });



    handleEditVersionClick = (evt: any) => {
    }

    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (prevState.updateProps) {
            return {
                tempMasterConcept: nextProps.masterConcept
            }
        }
        else
            return null;
    }


    savingConceptMapping() {
        let { yourConcept, yourConceptWithParent, unMappedData } = this.state;
        let { parentId, groupId, courseId } = this.props.match.params;
        let { courseData } = this.props;
        let mappedConcept: any = {};
        let promisesConcept: any = [];
        let url = "";

        if (!_.isEmpty(yourConceptWithParent)) {
            Object.keys(yourConceptWithParent).map(ys => {
                let masterId = yourConceptWithParent[ys].masterPresent.map((mp: any) => mp._id);
                
                const conceptCodes =  yourConceptWithParent[ys].masterPresent.map((mp: any) => mp.conceptCode);
                yourConceptWithParent[ys].data.map((md: any) => {
                    if (!_.isEmpty(md)) {
                        md["masterIDs"] = masterId;
                        md['conceptCodes'] = conceptCodes;
                        promisesConcept.push(GoalManagementService.mapCourses(md));
                    }
                });
            });
            return Promise.all(promisesConcept)
                .then((resPromises: any) => {
                    url = GoalManagementService.syncAndNext(parentId, unMappedData, courseData, groupId, courseId);
                    location.replace(url);
                })
        } else {
            url = GoalManagementService.syncAndNext(parentId, unMappedData, courseData, groupId, courseId);
            location.replace(url);
        }
    }

    toggleYourChapter(chapterId: any, isAdd: boolean, e: any) {
        let { yourConceptWithParent, selectedConceptId, tempYourConcept } = this.state;
        tempYourConcept.map((yc: any) => {
            if (yc._id == chapterId) {
                selectedConceptId = chapterId;
                yc['selected'] = isAdd;
                yc['showInSelected'] = false;
                let a = { masterPresent: [], data: [yc] };
                yourConceptWithParent[yc._id] = a;
            }
        });
        this.setState({ tempYourConcept, yourConceptWithParent, selectedConceptId });
        this.calculateProgress();
    }

    toggleYourChapterWithParent(conceptId: string, e: any) {
        this.setState({ selectedConceptId: conceptId });
    }

    handleLinkingYourChapter(indexId: string, yourConceptId: string, e: any) {
        let { tempYourConcept, yourConceptWithParent, selectedConceptId } = this.state;


        let dataLength = yourConceptWithParent[yourConceptId] ? yourConceptWithParent[yourConceptId].data.length : 0;

        //We have data length which nedd to be handle 
        if (dataLength >= 2) {
            let temp: any = yourConceptWithParent[yourConceptId].data.filter((d: any) => d._id != yourConceptId);

            if (temp.length > 0) {
                let obj: any = temp[0];
                selectedConceptId = obj._id;
                yourConceptWithParent[selectedConceptId] = { data: temp, masterPresent: yourConceptWithParent[yourConceptId].masterPresent };
            }
        } else {
            //make master visible
            if (yourConceptWithParent[yourConceptId]) {
                yourConceptWithParent[yourConceptId].masterPresent.map((mp: any) => {
                    mp['showInSelected'] = true;
                });
            }
            else {
                let temp: any = yourConceptWithParent[indexId].data.filter((d: any) => d._id != yourConceptId);
                yourConceptWithParent[indexId].data = temp;
            }

        }


        delete yourConceptWithParent[yourConceptId];
        tempYourConcept.map((yc: any) => {
            if (yc._id == yourConceptId) {
                yc['selected'] = false;
                yc['showInSelected'] = true;
            }
        });
        this.setState({ tempYourConcept, yourConceptWithParent, selectedConceptId });
        this.calculateProgress();

    }

    linkMasterChapter(mConceptDetails: any, e: any) {
        let { selectedConceptId, yourConceptWithParent, tempMasterConcept } = this.state;
        if (!_.isEmpty(yourConceptWithParent)) {


            let isMutipleSubjectPresent = yourConceptWithParent[selectedConceptId].data.length;
            if (isMutipleSubjectPresent < 2) {

                let isThere = yourConceptWithParent[selectedConceptId].masterPresent.some((yc: any) => yc._id == mConceptDetails._id);
                if (!isThere) {
                    tempMasterConcept.map((ms: any) => {
                        if (ms._id == mConceptDetails._id) {
                            ms['showInSelected'] = false;
                        }
                    });

                    yourConceptWithParent[selectedConceptId].masterPresent.push(mConceptDetails);
                    this.setState({ yourConceptWithParent });
                    this.calculateProgress();
                }
            }
        }
    }

    removeMasterChapter(masterConceptId: string, e: any) {
        let { selectedConceptId, yourConceptWithParent, tempMasterConcept } = this.state;
        if (!_.isEmpty(yourConceptWithParent)) {



            //Check for multiple data
            let dataLength = yourConceptWithParent[selectedConceptId].data.length;

            //This will help to split data and show in different way
            if (dataLength > 0) {
                //Doing this since we have to remove other master from data array;
                yourConceptWithParent[selectedConceptId].data.map((d: any, i: number) => {
                    if (!yourConceptWithParent[d._id]) {
                        yourConceptWithParent[d._id] = { data: [d], masterPresent: [] };
                    }
                });

                let test = yourConceptWithParent[selectedConceptId].data.find((da: any) => da._id === selectedConceptId)
                yourConceptWithParent[selectedConceptId].data = [test];
            }
            //This will help in hidding in master subject;
            tempMasterConcept.map((ms: any) => {
                if (ms._id == masterConceptId) {
                    ms['showInSelected'] = true;
                }
            });


            let a = yourConceptWithParent[selectedConceptId].masterPresent.filter((mp: any) => mp._id != masterConceptId);
            yourConceptWithParent[selectedConceptId].masterPresent = a;
            this.setState({ yourConceptWithParent });
            this.calculateProgress();
        }
    }

    handleSearchYourConcept(evt: any) {
        let { tempYourConcept, yourConcept } = this.state;
        let { name, value } = evt.target;
        tempYourConcept = [];
        if (!value) {
            tempYourConcept = yourConcept;
        } else {
            yourConcept.map((yc: any) => {
                if (yc.name.toLowerCase().search(value.toLowerCase()) != -1) {
                    tempYourConcept.push(yc);
                }
            });
        }
        this.setState({ tempYourConcept });
    }

    handleSearchMaster(evt: any) {
        let { tempMasterConcept } = this.state;
        let { masterConcept } = this.props;
        let { name, value } = evt.target;
        tempMasterConcept = [];
        if (!value) {
            tempMasterConcept = masterConcept;
        } else {
            masterConcept.map((mc: any) => {
                if (mc.name.toLowerCase().search(value.toLowerCase()) != -1) {
                    tempMasterConcept.push(mc);
                }
            });
        }
        this.setState({ tempMasterConcept, updateProps: false });
    }

    calculateProgress() {
        let { yourConcept, yourConceptWithParent, mappedPer } = this.state;
        let mappedPercentage: number = 0;
        let numerator: number = 0;
        let denominator: number = 0;

        Object.keys(yourConceptWithParent).forEach((d) => {
            let yourSubjectCount = yourConceptWithParent[d].data.length;
            if (!_.isUndefined(yourConceptWithParent[d].masterPresent) && yourConceptWithParent[d].masterPresent.length) {
                numerator = yourSubjectCount + numerator;

            }
        })
        denominator = yourConcept.length;
        mappedPercentage = (numerator / denominator) * 100;
        mappedPer = denominator ? mappedPercentage : 0;
        this.setState({ mappedPer });
    }


    linkWithMultipleParent(subSubjectId: any, e: any) {
        let { selectedConceptId, yourConceptWithParent, yourConcept } = this.state;
        let conceptObj: any = _.find(yourConcept, ['_id', subSubjectId]);

        if (!_.isEmpty(yourConceptWithParent) && !_.isUndefined(conceptObj)) {
            let masterAlreadyMapped = yourConceptWithParent[conceptObj._id].masterPresent.length;
            //Check for selectedSubSubjectId wther it has master length 0 and to which data is been pushed check length should be 1 then only allow to push
            if (_.isEmpty(yourConceptWithParent[selectedConceptId].masterPresent) && masterAlreadyMapped < 2) {
                let selectedSubjectData = yourConceptWithParent[selectedConceptId].data[0];
                yourConceptWithParent[conceptObj._id].data.push(selectedSubjectData);

                delete yourConceptWithParent[selectedConceptId];
                selectedConceptId = conceptObj._id;
            }
            this.setState({ yourConceptWithParent, selectedConceptId });
            this.calculateProgress();
        }

    }

    render() {
        const { classes, courseData, match } = this.props;
        const parentId = match.params.parentId ? match.params.parentId : '';
        const { moreMenuAnchor, mappedPer, tempYourConcept, yourConceptWithParent, tempMasterConcept, selectedConceptId } = this.state;
        const { courseId, groupId } = match.params;

        let conceptName: any = "";
        let a: any = !_.isEmpty(courseData) ? _.find(courseData, { '_id': parentId }) : {};
        conceptName = _.get(a, 'name', '');

        return (
            <>
                <Grid container spacing={8} alignItems="center" justify="space-between" className={classes.mb2x}>
                    <Grid item xs="auto">
                        <Grid container alignItems="center" className={classes.pageTitle}>
                            <MyPATLink to={`/goal-management/edit/${groupId}/#${courseId}`}>
                                <BackIcon />
                            </MyPATLink>
                            <Typography variant="h6" inline>Goal Mapping</Typography>
                        </Grid>
                    </Grid>

                    <Grid item xs="auto">
                        <MyPATIconButton
                            buttonVariant="bordered"
                            aria-haspopup="true"
                            onClick={this.handleMoreMenuOpen.bind(this)}
                        >
                            <MoreIcon />
                        </MyPATIconButton>
                        <Menu
                            open={Boolean(moreMenuAnchor)}
                            anchorEl={moreMenuAnchor}
                            onClose={this.handleMoreMenuClose.bind(this)}
                            className={classes.moreMenu}
                        >
                            <MenuItem onClick={this.handleMoreMenuClose.bind(this)}>
                                Menu Item
            </MenuItem>
                        </Menu>
                    </Grid>
                </Grid>

                <MyPATExpansionPanel
                    panelProps={{
                        expanded: true
                    }}
                    hasExpandIcon={false}
                    customCollapseTitle={
                        <Grid container alignItems="center" justify="space-between">
                            <Grid item xs={9}>
                                <Typography variant="h6">Concept Mapping</Typography>
                            </Grid>
                            <Grid item xs={1}>
                                <div className={classes.progressWrapper}>
                                    <LinearProgress className={classes.progressBar} variant="determinate" value={mappedPer} />
                                </div>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography align="center"
                                    onClick={this.savingConceptMapping.bind(this)}
                                    variant="body1">
                                    <Button variant="contained" color="primary"> Sync And Next </Button>
                                </Typography>
                            </Grid>
                        </Grid>
                    }
                >
                    <Grid container className={classes.root} spacing={16} alignItems="flex-start">
                        <Grid item xs={12}>
                            <Grid container className={classes.pB8} alignItems="flex-start">
                                <Grid item xs={6}>
                                    <Typography variant="h5" inline align="left">Your Concepts</Typography>
                                    <Paper className={classes.paper}>
                                        <Grid container>
                                            <Grid item xs={9} className={classes.yourChapter}>
                                                <Typography inline component="div" className={classes.umMappedHeader} variant="h5" align="left">{conceptName} </Typography>
                                            </Grid>
                                            <Grid item xs={3} className={classes.p12}>
                                                <SearchField
                                                    id="searchFieldYour"
                                                    placeholder="Search"
                                                    className={classes.searchInputRoot}
                                                    onChange={this.handleSearchYourConcept.bind(this)}
                                                />

                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="h5" inline align="left">Master Concepts</Typography>
                                    <Paper className={classes.paper}>
                                        <Grid container>
                                            <Grid item xs={9} className={classes.yourChapter}>
                                                <Typography inline component="div" className={classes.umMappedHeader} variant="h5" align="left">{conceptName} </Typography>
                                            </Grid>
                                            <Grid item xs={3} className={classes.p12}>
                                                <SearchField
                                                    id="searchFieldMaster"
                                                    placeholder="Search"
                                                    className={classes.searchInputRoot}
                                                    onChange={this.handleSearchMaster.bind(this)}
                                                />

                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>

                            {
                                !_.isEmpty(yourConceptWithParent) && Object.keys(yourConceptWithParent).map((yc: any, i: number) => {
                                    return (
                                        <div key={`selected_${yc}_${i}`} className={classes.cardParent}>
                                            <Grid container alignItems="flex-start" alignContent="center">
                                                <Grid item xs={6} className={classes.inMaster}>
                                                    {
                                                        _.map(yourConceptWithParent[yc].data, (chapter: any, j: number) => (
                                                            <ListItem
                                                                key={`${chapter._id}_${i}`}
                                                                className={classes.mapping}
                                                                divider={true}
                                                            >
                                                                <ListItemText
                                                                    primaryTypographyProps={{ variant: 'body1' }}
                                                                >
                                                                    {`${i + 1}. ${chapter.name}`}
                                                                    {
                                                                        !_.isEqual(yc, selectedConceptId)
                                                                            ?
                                                                            <MyPATIconButton
                                                                                buttonVariant="flat"
                                                                                aria-haspopup="true"
                                                                                onClick={this.toggleYourChapterWithParent.bind(this, yc)}
                                                                                className={classes.moreMenuButton}
                                                                            >
                                                                                <AddIcon className={classes.addIcon} />
                                                                            </MyPATIconButton>
                                                                            :
                                                                            <MyPATIconButton
                                                                                buttonVariant="flat"
                                                                                aria-haspopup="true"
                                                                                onClick={this.handleLinkingYourChapter.bind(this, yc, chapter._id)}
                                                                                className={classes.moreMenuButton}
                                                                            >
                                                                                <CloseIcon className={classes.closeIcon} />
                                                                            </MyPATIconButton>
                                                                    }
                                                                </ListItemText>
                                                            </ListItem>

                                                        ))
                                                    }

                                                </Grid>
                                                <Grid item xs={6} className={classes.inMaster}>
                                                    {
                                                        _.map(yourConceptWithParent[yc].masterPresent, (masterChapter, k: number) => (
                                                            <ListItem
                                                                key={`${masterChapter._id}_${k}`}
                                                                className={classes.mapping}
                                                                divider={true}
                                                            >
                                                                <ListItemText
                                                                    primaryTypographyProps={{ variant: 'body1' }}
                                                                >
                                                                    {`${k + 1}. ${masterChapter.name}`}
                                                                    {
                                                                        _.isEqual(yc, selectedConceptId)
                                                                            ?
                                                                            <MyPATIconButton
                                                                                buttonVariant="flat"
                                                                                aria-haspopup="true"
                                                                                onClick={this.removeMasterChapter.bind(this, masterChapter._id)}
                                                                                className={classes.masterMoreMenuButton}
                                                                            >
                                                                                <CloseIcon className={classes.closeIcon} />
                                                                            </MyPATIconButton>
                                                                            :
                                                                            <MyPATIconButton
                                                                                buttonVariant="flat"
                                                                                aria-haspopup="true"
                                                                                onClick={this.linkWithMultipleParent.bind(this, yc)}
                                                                                className={classes.masterMoreMenuButton}
                                                                            >
                                                                                <AddIcon className={classes.addIcon} />
                                                                            </MyPATIconButton>
                                                                    }
                                                                </ListItemText>
                                                            </ListItem>
                                                        ))
                                                    }
                                                </Grid>
                                            </Grid>
                                        </div>
                                    )
                                })
                            }


                            <Grid container alignItems="flex-start" alignContent="center">
                                <Grid item xs={6}>
                                    <Paper className={classes.paper}>
                                        <List
                                            component="nav"
                                            className={classes.root}
                                        >

                                            {
                                                _.map(tempYourConcept, (chapter, j) => {
                                                    return (
                                                        (_.isUndefined(chapter.showInSelected) || _.isEqual(chapter.showInSelected, true))
                                                        &&
                                                        <ListItem
                                                            key={`${chapter._id}_${j}`}
                                                            className={classes.notMapped}
                                                            divider={true}
                                                        >
                                                            <ListItemText
                                                                primaryTypographyProps={{ variant: 'body1' }}
                                                            >
                                                                {`${j + 1}. ${chapter.name}`}

                                                                <MyPATIconButton
                                                                    buttonVariant="flat"
                                                                    aria-haspopup="true"
                                                                    onClick={this.toggleYourChapter.bind(this, chapter._id, true)}
                                                                    className={classes.moreMenuButton}
                                                                >
                                                                    <AddIcon className={classes.addIcon} />
                                                                </MyPATIconButton>
                                                            </ListItemText>
                                                        </ListItem>

                                                    );
                                                })
                                            }

                                        </List>
                                    </Paper>
                                </Grid>
                                <Grid item xs={6}>
                                    <Paper className={classes.paper}>
                                        <List
                                            component="nav"
                                            className={classes.root}
                                        >
                                            {
                                                _.map(tempMasterConcept, (masterC, j) => {
                                                    return (
                                                        (_.isUndefined(masterC.showInSelected) || _.isEqual(masterC.showInSelected, true))
                                                        &&
                                                        <ListItem
                                                            key={`${masterC._id}_${j}`}
                                                            className={classes.notMapped}
                                                            divider={true}
                                                        >

                                                            <ListItemText
                                                                primaryTypographyProps={{ variant: 'body1' }}
                                                            >
                                                                <Grid container>
                                                                    <Grid item xs={6}>
                                                                        {`${j + 1}. ${masterC.name}`}
                                                                        {!_.isEmpty(selectedConceptId) &&
                                                                            <MyPATIconButton
                                                                                buttonVariant="flat"
                                                                                aria-haspopup="true"
                                                                                onClick={this.linkMasterChapter.bind(this, masterC)}
                                                                                className={classes.masterMoreMenuButton}
                                                                            >
                                                                                <AddIcon className={classes.addIcon} />
                                                                            </MyPATIconButton>
                                                                        }
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Typography inline className={classes.uniqueIdText}>
                                                                            {_.get(masterC, 'uniqueCode', '')}
                                                                        </Typography>
                                                                    </Grid>
                                                                </Grid>
                                                            </ListItemText>
                                                        </ListItem>

                                                    );
                                                })
                                            }

                                        </List>
                                    </Paper>
                                </Grid>
                            </Grid>

                        </Grid>
                    </Grid>
                </MyPATExpansionPanel>
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    masterConcept: _.get(state, 'goalManagement.goalManagement.conceptList', []),
    courseData: _.get(state, 'goalManagement.goalManagement.courseData', []),
});


const mapDispatchToProps = (dispatch: any) => bindActionCreators({
    getMaster,
    getCourseData,
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ConceptMappingContainer));